import { render, staticRenderFns } from "./GroupBlock.vue?vue&type=template&id=88638986&scoped=true"
import script from "./GroupBlock.vue?vue&type=script&lang=js"
export * from "./GroupBlock.vue?vue&type=script&lang=js"
import style0 from "./GroupBlock.vue?vue&type=style&index=0&id=88638986&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88638986",
  null
  
)

export default component.exports